import React, { Component } from 'react';
import './ShoutoutImage.scss';
import { showFullscreenImage } from '../actions/ShoutoutsActions';
import { connect } from 'react-redux';
import { Icon } from '@material-ui/core';

class ShoutoutImage extends Component {
  image = null;
  state = { overlayWidth: null }

  handleTallImage() {
    this.image.classList.add('max-height');
    this.setState({ overlayWidth: this.image.clientWidth });
  }

  handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.showFullscreenImage(this.props.shoutout.imageUrl);
  }

  render() {
    const { shoutout, screen } = this.props;
    if (!shoutout || !shoutout.imageUrl) return null;


    let hoverClass = this.state.overlayWidth ? 'hover-text max-height-overlay' : 'hover-text';
    let className = screen ? "image-preview-wrapper " + screen : "image-preview-wrapper";
    let imageUrl = shoutout.previewImageUrl ? shoutout.previewImageUrl : shoutout.imageUrl;
    if (this.state.overlayWidth) className += " sides";

    return (
      <div className={className}>
        <img
          ref={(ref) => this.image = ref}
          onClick={(e) => this.handleClick(e)}
          onLoad={() => { if (this.image.clientHeight > 773) this.handleTallImage(); }}
          className="shoutout-image"
          src={imageUrl}
          alt=""
        >
        </img>
        <div
          style={{ width: this.state.overlayWidth || 'calc(100% + 32px)' }}
          className={hoverClass}
          onClick={(e) => this.handleClick(e)}
        >
          <Icon>zoom_in</Icon>
          <div>Click to open photo in fullscreen</div>
        </div>
      </div>
    );
  }
}


export default connect(null, { showFullscreenImage })(ShoutoutImage);


// WEBPACK FOOTER //
// ./src/components/ShoutoutImage.js